import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { formatRegimenSatSelectLabel, REGIMENES_SAT } from "@/lib/regimenesSat";

/** Formulario compacto de perfil comprador (sin llaves técnicas ni logo). */
export default function BuyerProfileEditForm({ prof, setProf, disabled = false }) {
  return (
    <div className="space-y-4" data-testid="buyer-profile-edit-form">
      <div>
        <Label className="text-xs">Nombre comercial</Label>
        <Input
          value={prof.nombre_comercial}
          onChange={(e) => setProf({ ...prof, nombre_comercial: e.target.value })}
          disabled={disabled}
          className="mt-1 h-9 text-sm"
        />
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div>
          <Label className="text-xs">Razón social</Label>
          <Input
            value={prof.razon_social}
            onChange={(e) => setProf({ ...prof, razon_social: e.target.value })}
            disabled={disabled}
            className="mt-1 h-9 text-sm"
          />
        </div>
        <div>
          <Label className="text-xs">RFC</Label>
          <Input
            value={prof.rfc}
            onChange={(e) => setProf({ ...prof, rfc: e.target.value.toUpperCase() })}
            disabled={disabled}
            className="mt-1 h-9 text-sm font-mono"
          />
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div>
          <Label className="text-xs">Código postal</Label>
          <Input
            value={prof.codigo_postal}
            onChange={(e) => setProf({ ...prof, codigo_postal: e.target.value })}
            disabled={disabled}
            maxLength={5}
            className="mt-1 h-9 text-sm font-mono"
          />
        </div>
        <div>
          <Label className="text-xs">Régimen fiscal</Label>
          <Select
            value={prof.regimen_fiscal}
            onValueChange={(v) => setProf({ ...prof, regimen_fiscal: v })}
            disabled={disabled}
          >
            <SelectTrigger className="mt-1 h-9 text-xs">
              <SelectValue placeholder="Selecciona régimen" />
            </SelectTrigger>
            <SelectContent>
              {REGIMENES_SAT.map((r) => (
                <SelectItem key={r.c} value={r.c}>
                  {formatRegimenSatSelectLabel(r)}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div>
        <Label className="text-xs">Domicilio fiscal</Label>
        <Input
          value={prof.domicilio}
          onChange={(e) => setProf({ ...prof, domicilio: e.target.value })}
          disabled={disabled}
          className="mt-1 h-9 text-sm"
        />
      </div>
      <div>
        <Label className="text-xs">Correo de facturación</Label>
        <Input
          value={prof.correo_facturacion}
          onChange={(e) => setProf({ ...prof, correo_facturacion: e.target.value })}
          disabled={disabled}
          className="mt-1 h-9 text-sm font-mono"
        />
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div>
          <Label className="text-xs">Responsable</Label>
          <Input
            value={prof.responsable}
            onChange={(e) => setProf({ ...prof, responsable: e.target.value })}
            disabled={disabled}
            className="mt-1 h-9 text-sm"
          />
        </div>
        <div>
          <Label className="text-xs">Teléfono</Label>
          <Input
            value={prof.telefono}
            onChange={(e) => setProf({ ...prof, telefono: e.target.value })}
            disabled={disabled}
            className="mt-1 h-9 text-sm"
          />
        </div>
      </div>
      <div>
        <Label className="text-xs">Correo de contacto</Label>
        <Input
          value={prof.email}
          onChange={(e) => setProf({ ...prof, email: e.target.value })}
          disabled={disabled}
          className="mt-1 h-9 text-sm"
        />
      </div>
    </div>
  );
}
